import { Stop } from '@dynamika-shared/ui/icons/Stop';
import { twMerge } from '@utils/twMerge';
import { Tag, Tooltip } from 'antd';
import { FC } from 'react';
import { Option } from '@utils/generateOptions';

const MAX_LABEL_LENGTH = 35;

const isOverMaxLen = (len: number) => len > MAX_LABEL_LENGTH;

type SelectedItemsProps = {
  selectedItems: Option[];
  onClose: (item: Option) => void;
  title: string;
  className?: string;
};
export const SelectedItems: FC<SelectedItemsProps> = ({
  selectedItems,
  onClose,
  title,
  className,
}) => {
  return (
    <div
      data-testid='SelectedItems'
      className={twMerge(className, 'flex flex-col')}
    >
      {!!selectedItems.length && (
        <span className='mt-1 text-1016 text-dimGray'>{title}</span>
      )}
      {selectedItems.map(item => (
        <Tag
          key={item.value}
          data-testid={'selected-item'}
          closeIcon={
            <span onClick={() => onClose(item)}>
              <Stop width={20} height={20} />
            </span>
          }
          closable
          className='mr-0 mt-1 flex h-[4.8rem] items-center justify-between rounded-md border-none bg-waterLightHover50 p-[1.4rem] leading-none'
        >
          <Tooltip
            color='white'
            title={
              item.label.length > MAX_LABEL_LENGTH ? (
                <span className='text-1424 text-black'>{item.label}</span>
              ) : undefined
            }
          >
            <span
              style={{
                maxWidth: isOverMaxLen(item.label.length)
                  ? `${MAX_LABEL_LENGTH}rem`
                  : 'none',
              }}
              className={twMerge(
                'text-1624 font-medium leading-6',
                isOverMaxLen(item.label.length) && 'truncate'
              )}
            >
              {item.label}
            </span>
          </Tooltip>
        </Tag>
      ))}
    </div>
  );
};
